import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { popupType } from './../../';
import SuccessText from './../modal-popup/success-text';

class Main extends React.Component {
	constructor(props) {
		super(props);
		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.handleEscButtonPress = this.handleEscButtonPress.bind(this);
	}
	setWrapperRef(node) {
		this.wrapperRef = node;
	}
	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.props.hidePopup();
		}
	}
	handleEscButtonPress(e) {
		e.key == 'Escape' && (this.props.hidePopup());
	}
	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleEscButtonPress);
		document.removeEventListener('click', this.handleClickOutside);
	}
	render() {
		const { intl, isOrderButtonDisabled, hidePopup, popupInfo } = this.props;

		let popupText;
		let buttons = <div className="buttons-continer">
			<button
				className="btn btn_order btn_hover yes"
				disabled={isOrderButtonDisabled}
				onClick={() => this.props.handleOrder()}
			>
				{intl('Yes')}
			</button>
			<button
				className="button cancel font-proxima-nova-semibold btn_hover no"
				onClick={hidePopup}
			>
				{intl('No')}
			</button>
		</div>;
		switch (popupInfo.popup_type) {
			case popupType.confimPopup: popupText = intl('Do you confirm your order?'); break;
			case popupType.error: popupText = intl('Order failed'); break;
			case popupType.success:
				popupText = <SuccessText intl={intl} is_exchange_allowed={!!popupInfo.good.is_exchange_allowed} />;
				buttons =
					<div className="buttons-continer">
						<button
							className="btn btn_order btn_hover yes"
							onClick={hidePopup}
						>
							{intl('Understand')}
						</button>
					</div>;
				break;
			default: popupText = '';
				buttons = '';
		}
		if (this.props.popupInfo.isVisible) {
			document.addEventListener('click', this.handleClickOutside);
			document.addEventListener('keydown', this.handleEscButtonPress);
		} else {
			document.removeEventListener('keydown', this.handleEscButtonPress);
			document.removeEventListener('click', this.handleClickOutside);
		}
		return popupInfo && popupInfo.isVisible ? (
			<div className={`popup_container ${popupInfo.popup_type}`}>
				<div className="popup-order" ref={this.setWrapperRef} >
					<a href="#" className="modal-close" onClick={e => {
						e.preventDefault();
						hidePopup();
					}}></a>
					<div className="font-proxima-nova-regular modal-text">
						{popupText}
					</div>
					{buttons}
				</div>
			</div>
		): null;
	}
}

Main.propTypes = {
	intl: PropTypes.func,
	popupInfo: PropTypes.object,
	hidePopup: PropTypes.func,
	handleOrder: PropTypes.func,
	togglePopup: PropTypes.func,
	cancelationClick: PropTypes.func
};

export default Main;


// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/modal-popup/main.js